import axios from "axios";
import { useCancelToken } from "hooks";
import _ from "lodash";
import { useEffect, useCallback, useState } from "react";

const useLoadStates = (httpRequest, { withAutoLoading = false }) => {
  const [states, setStates] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const { getCancelToken } = useCancelToken()

  const loadStates = useCallback(async () => {
    setIsLoading(true);
    const response = await httpRequest({
      method: 'get',
      url: '/states',
      cancelToken: getCancelToken(),
    }).catch((error) => {
      setIsLoading(axios.isCancel(error));
    });

    if (response) {
      const data = _.get(response, 'data.data', []);
      setIsLoading(false);
      setStates(data);
    }
  }, [httpRequest, getCancelToken])

  useEffect(() => {
    if (withAutoLoading) {
      loadStates();
    }
  }, [loadStates, withAutoLoading])

  return ({ states, isLoading, loadStates });
}

export default useLoadStates;